import React, { Component } from 'react';
import {
  withRouter
} from 'react-router-dom';
import {
  reqUserAuthInstall
} from "../../../api";
import SkeltonSpinnerLoading from '../../../components/SkeltonSpinnerLoading';
import { store } from '../../../redux/store';
import { setMidIntercomInfo } from '../../../redux/actions/getAppPublicData';

class install extends Component {
  componentDidMount() {
    if (window.shopify) {
      const params = new URLSearchParams(window.location.search);
      window.SEOAntHost = params.get("host");
      // 获取联盟cookie
      const affiliateUtm = getCookie("utm_content");
      if (Boolean(affiliateUtm)) {
        params.set("seoant_mp_utm_content", affiliateUtm);
      }
      this.UserAuthInstall(params);
    } else {
      this.handleTabChange("/dashboard");
    }
  }

  // 重新渲染页面
  handleTabChange = (historyUrl) => {
    const { history } = this.props;
    history.push(historyUrl);
  };

  //获取当前抓取状态
  UserAuthInstall = async (par) => {
    // const params = {
    //   'embedded': par.get("embedded"),
    //   'shop': par.get("shop"),
    //   'hmac': par.get("hmac"),
    //   'host': par.get("host"),
    //   'locale': par.get("locale"),
    //   'session': par.get("session"),
    //   'timestamp': par.get("timestamp"),
    //   'id_token': par.get("id_token"),
    // };

    const response = await reqUserAuthInstall(par);
    if (response.code === 301) {
      window.location.href = response.url;
    } else if (response.code === 200) {
      // 先判断以及redux存储中台jwt状态
      const j_token = response?.data?.intercom_user_jwt || '';
      let midInfo = {
        exist: Boolean(j_token),
        jwt: j_token,
      }
      store.dispatch(setMidIntercomInfo(midInfo));
      this.handleTabChange(response.data.redirection_url);
    } else {
      console.error('error:', response?.msg);
    }
  }

  render() {
    return (
      <SkeltonSpinnerLoading />
    )
  }
}

// 获取cookie
function getCookie(cookieName) {
  var totalCookie = document.cookie;
  var cookieStartAt = totalCookie.indexOf(cookieName + "=");
  if (cookieStartAt === -1) {
    return;
  }
  var valueStartAt = totalCookie.indexOf("=", cookieStartAt) + 1;
  var valueEndAt = totalCookie.indexOf(";", cookieStartAt);
  if (valueEndAt === -1) {
    valueEndAt = totalCookie.length;
  }
  var cookieValue = unescape(totalCookie.substring(valueStartAt, valueEndAt));
  return cookieValue;
}

export default withRouter(install);